import { Card } from '@/components/sections/Card';
import { cn } from '@/lib/utils';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import DaasTableHeaderCell from './DaasTableHeaderCell';
import { SortDirection } from './sortHelper';

export interface DaasTableColumn {
  accessor: string;
  subAccessor?: string;
  sortable?: boolean;
  text: string;
  subHeaders?: string[];
  size?: string;
}

interface Props extends PropsWithChildren {
  headers: DaasTableColumn[];
  onSortCallback?: (columnId: string, direction: SortDirection, subColumnId?: string) => void;
  sortColumnId?: string;
  sortDirection?: SortDirection;
  sortSubColumnId?: string;
  className?: string;
}

const DaaSTable: FunctionComponent<Props> = ({
  headers,
  onSortCallback,
  sortColumnId,
  sortDirection,
  sortSubColumnId,
  className,
  children
}) => {
  if (headers.length === 0) {
    throw Error('Headers must be provided');
  }

  const gridTemplateColumns = headers.reduce((prevString, header) => {
    return `${prevString} ${header.size || '1fr'}`;
  }, '');

  const [activeSortColumnHeader, setActiveSortColumnHeader] = useState<string>('');

  return (
    <Card className={cn('border-[#DDDDDD] w-full', className)}>
      <div className={'min-w-[1000px] grid'} style={{ gridTemplateColumns }}>
        {headers.map(h => (
          <DaasTableHeaderCell
            header={h}
            key={h.accessor}
            onSortCallback={(direction: SortDirection, subColumnId?: string) => {
              onSortCallback && onSortCallback(h.accessor, direction, subColumnId);
              setActiveSortColumnHeader(h.accessor);
            }}
            sortDirection={sortColumnId === h.accessor ? sortDirection : undefined}
            sortSubColumnId={sortSubColumnId}
            activeSort={activeSortColumnHeader === h.accessor}
          />
        ))}
        {children}
      </div>
    </Card>
  );
};

export default DaaSTable;
